import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../css/OrderList.css';

const OrderList = () => {
  const [orders, setOrders] = useState([]);
  const [addressMap, setAddressMap] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const token = localStorage.getItem('token');
        const ordersResponse = await axios.get(`${process.env.REACT_APP_API_URL}/api/orders/get`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setOrders(ordersResponse.data);

        // Fetch addresses for all orders
        const addressPromises = ordersResponse.data.map((order) =>
          axios.get(`${process.env.REACT_APP_API_URL}/api/user/getAddress/${order.address}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
        );
        const addressResponses = await Promise.all(addressPromises);
        const addressData = {};
        ordersResponse.data.forEach((order, index) => {
          addressData[order.address] = addressResponses[index].data;
        });
        setAddressMap(addressData);
      } catch (error) {
        console.error('Failed to fetch orders or addresses:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  const handleTrackOrder = (orderId) => {
    navigate(`/track-order/${orderId}`);
  };

  if (loading) {
    return <div>Loading orders...</div>;
  }

  return (
    <div className="order-list-container">
      <h2>Your Orders</h2>
      {orders.map((order) => (
        <div key={order.id} className="order-card">
          <h3>Order ID: {order.id}</h3>
          <div className="order-items">
            {order.items.map((item) => (
              <div key={item.id} className="order-item">
                <img src={`/uploads/${item.product.images[0]?.imageUrl}`} alt="Product" className='product-image-1'/>
                <div>
                  <p><strong>Product ID:</strong> {item.product.id}</p>
                  <p><strong>Price:</strong> ₹{item.price.toFixed(2)}</p>
                  <p><strong>Quantity:</strong> {item.quantity}</p>
                </div>
              </div>
            ))}
          </div>
          <p><strong>Total Price:</strong> ₹{order.totalPrice.toFixed(2)}</p>
          <p><strong>status:</strong> ₹{order.status}</p>
          {addressMap[order.address] && (
            <div className="order-address">
              <p><strong>Address:</strong> {addressMap[order.address].addressLine1}, {addressMap[order.address].city}, {addressMap[order.address].state}, {addressMap[order.address].postalCode}</p>
            </div>
          )}
          <button className="track-order-btn" onClick={() => handleTrackOrder(order.id)}>
            Track Order
          </button>
        </div>
      ))}
    </div>
  );
};

export default OrderList;
